import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useMemo, useState, useEffect } from "react";
import ProductPerfomance from "../components/dashboard/ProductPerfomance";
import FullLayout from "../components/layouts/FullLayout";
import TableFilter from "../components/dashboard/TableFilter";
import Card from "../components/Card/Card";
import { useRouter } from "next/router";
import { onGetDonors, onGetDonorsSummary } from "../src/utils/queries";
import GlobalFilter from "../components/Input/GlobalFilter";
import HeaderModal from "../components/Modal/HeaderModal";
import ExportTableForm from "../components/Form/ExportTableForm";
import moment from "moment";
import { formatAsMoney, getTruthyCount } from "../src/utils/services";
import SideNav from "../components/layouts/Nav/SideNav";
import { useAuthProvider } from "../context/AuthProvider";
import DonorSideInfo from "../components/partials/DonorSideInfo";
import PrivateRoute from "../components/Protected/ProtectedRoute";
const queryString = require("query-string");

const headers = [
  { label: "Donor ID", key: "id", checked: false },
  { label: "Name", key: "name", checked: false },
  { label: "Address", key: "address", checked: false },
  { label: "Email", key: "email", checked: false },
  { label: "Date registered", key: "created_at", checked: false },
  { label: "Phone number", key: "phone_number", checked: false },
  { label: "Number of Donations", key: "number_of_donations", checked: false },
  { label: "Total Amount Amount", key: "total_donation_amount", checked: false },
  { label: "Average donation", key: "average_donation", checked: false },
];

export default function Donors({ props }) {
  moment.updateLocale("en", {
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      w: "a week",
      ww: "%d weeks",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years",
    },
  });

  const router = useRouter();
  const [fields, setFields] = useState(headers);
  const [checkAllFields, setCheckedFields] = useState(false);
  const [calledData, setCalledData] = useState([]);
  const [summaryCalledData, setSummaryCalledData] = useState({});
  const [value, setValue] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedStructuredRows, setSelectedStructuredRows] = useState([]);
  const [exportShowModal, setExportModal] = useState(false);
  const [showSideNav, setShowSideNav] = useState(false);
  const [clickedRow, setClickedRow] = useState({});
  const [lastPage, setLastPage] = useState(1);
  const { user } = useAuthProvider();
  const date = moment();

  const defaultState = {
    per_page: 100,
    page: 1,
    date_range: undefined,
    date_from: undefined,
    date_to: undefined,
    amount_from: undefined,
    amount_to: undefined,
    donor_name: undefined,
    postal_code: undefined
  };

  const defaultLocalState = {
    date_range: "Anytime",
    dateValue: [date, date],
    amount_from: 0,
    amount_to: 1000,
    donor_name: "",
    postal_code: ""
  };

  const [filters, setFilters] = useState(defaultState);
  const [localFilters, setLocalFilters] = useState(defaultLocalState);
  const countDefined = (obj) => {
    return Object.entries(obj).filter(([key, value]) => value !== undefined).length;
  };
  const query = queryString.stringify(filters, { encode: false });
  const { isLoading, isSuccess, error, isError, data } = onGetDonors((countDefined(filters) > 2) ? query : '');

  const {
    isLoading: summaryLoading,
    isSuccess: summarySuccess,
    error: summaryError,
    isError: summaryCheckError,
    data: summaryData,
  } = onGetDonorsSummary();


  useEffect(() => {
    if (isSuccess) {
      const hasDonations = data.data.data
        .filter(({ donations }) => donations.length)
        .map((datum) => {
          return {
            ...datum,
            first_name: datum.first_name + " " + datum.last_name,
          };
        });

      setCalledData(hasDonations);
      setLastPage(data.data.last_page);
    }
    if (isError) {
      console.log(error.response, error);
    }
    //put the dependencies in later
  }, [isSuccess, isError, data]);

  useEffect(() => {
    if (summarySuccess) {
      const summarisedData = summaryData.data.data;
      setSummaryCalledData(summarisedData);
    }
    if (summaryCheckError) {
      console.log(summaryError.response);
    }
    //put the dependencies in later
  }, [summarySuccess, summaryError, summaryData]);

  const columns = useMemo(
    () =>
      user?.role?.id < 3
        ? [
          {
            Header: "S/N",
            accessor: "id",
            Cell: ({ cell }) => {
              return cell?.row?.index + 1;
            },
          },
          {
            Header: "Donor ID",
            accessor: "donor_code",
            Cell: ({ value, cell }) => {
              return `${cell?.row?.original?.donor_code}`;
            },
          },
          {
            Header: "NAME",
            accessor: "first_name",
            Cell: ({ value, cell }) => {
              return `${cell?.row?.original?.first_name}`;
            },
          },
          {
            Header: "POSTCODE",
            accessor: "postal_code",
            Cell: ({ value, cell }) => value,
          },
          {
            Header: "LAST DONATION",
            accessor: "donations[0].last_donation_date",
            Cell: ({ value, cell }) => {
              return moment(value).format("DD MMM YYYY");
            },
          },
          {
            Header: "NO OF DONATIONS",
            accessor: "donations[0].number_of_donations",
          },
          {
            Header: "TOTAL AMT",
            accessor: "donations[0].total_donation_amount",
            Cell: ({ value }) =>
              value ? (
                <Typography
                  variant="big"
                  component={"p"}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {formatAsMoney(value)}
                </Typography>
              ) : (
                <Typography
                  variant="big"
                  component={"p"}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {formatAsMoney(0)}
                </Typography>
              ),
          },
          {
            Header: "AVERAGE AMT",
            accessor: "donations[0].average_donation_amount",
            Cell: ({ value }) =>
              value ? (
                <Typography
                  variant="big"
                  component={"p"}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {formatAsMoney(value)}
                </Typography>
              ) : (
                <Typography
                  variant="big"
                  component={"p"}
                  sx={{
                    textAlign: "right",
                  }}
                >
                  {formatAsMoney(0)}
                </Typography>
              ),
          },
        ]
        : [
          {
            Header: "S/N",
            accessor: "id",
            Cell: ({ cell }) => {
              return cell?.row?.index + 1
            },
          },
          {
            Header: "NAME",
            accessor: "first_name",
            Cell: ({ value, cell }) => {
              return `${cell?.row?.original?.first_name} ${cell?.row?.original?.last_name}`;
            },
          },
          {
            Header: "POSTCODE",
            accessor: "postal_code",
            Cell: ({ value, cell }) => value,
          },
          {
            Header: "LAST DONATION",
            accessor: "created_at",
            Cell: ({ value, cell }) => {
              return moment(value).format("DD MMM YYYY");
            },
          },
          {
            Header: "NO OF DONATIONS",
            accessor: "donations[0].number_of_donations",
          },
        ],
    [user]
  );

  const rows = useMemo(() => calledData, [calledData]);

  const result = calledData.reduce((donor, item) => {
    const donation = item.donations[0];
    donor.number_of_donors += 1;
    donor.number_of_donations += parseFloat(donation.total_donation_amount);
    donor.total_donation_amount += donation.number_of_donations;
    return donor;
  }, {
    number_of_donors: 0,
    number_of_donations: 0,
    total_donation_amount: 0,
  });

  const average_donation_amount = (result.number_of_donations != 0 && result.total_donation_amount != 0) ? result.number_of_donations / result.total_donation_amount : 0;

  const handleChangePage = (page) => {
    setFilters({ ...filters, page });
  };

  const showFilterClear = getTruthyCount(0, filters);
  const cards = [
    {
      header: "NO. OF DONORS",
      body: !showFilterClear
        ? summaryCalledData?.number_of_donors : result.number_of_donors,
    },
    {
      header: "NO. OF DONATIONS",
      body: !showFilterClear
        ? summaryCalledData?.number_of_donations : result.total_donation_amount,
    },
    {
      header: "TOTAL DONATION AMOUNT",
      body: !showFilterClear
        ? formatAsMoney(summaryCalledData?.total_donation_amount) : formatAsMoney(result.number_of_donations),
    },
    {
      header: "AVG. DONATION AMOUNT",
      currency: "$",
      body: !showFilterClear
        ? formatAsMoney(summaryCalledData?.average_donation_amount) : formatAsMoney(average_donation_amount),
    },
  ];

  const supportCards = [
    {
      header: "NO. OF DONORS",
      body: summaryCalledData?.number_of_donors,
    },
    {
      header: "NO. OF DONATIONS",
      body: summaryCalledData?.number_of_donations,
    },
  ];

  useEffect(() => {
    if (selectedRows.length > 0) {
      const structuredRows = getData(selectedRows);
      setSelectedStructuredRows(structuredRows);
      return;
    }
    setSelectedStructuredRows([]);
  }, [selectedRows]);

  const getData = (data) => {
    const row = data.map((item) => {
      return {
        donor_id: `${item.original.donor_code}`, 
        name: `${item.original.first_name} ${item.original.last_name}`,
        address: `${item.original.city}, ${item.original.country_code}`,
        last_donation: moment(item.values.created_at).format("DD MMM YYYY"),
        no_of_donations: item.values["donations[0].number_of_donations"],
        average_amount: formatAsMoney(
          item.values["donations[0].average_donation_amount"]
        ),
        total_amount: formatAsMoney(
          item.values["donations[0].total_donation_amount"]
        ),
      };
    });

    return row;
  };

  const resetModalFields = () => {
    fields.map(field => field.checked = false)
    setFields([...fields])
    setCheckedFields(false)
  }

  return (
    <>
      <Box
        display="flex"
        justifyContent={"space-between"}
        alignItems="center"
        mb="2em"
      >
        <Typography variant="h4" component={"h2"}>
          Donors
        </Typography>
        <HeaderModal
          text={"Export list"}
          modalDescription={"Export list"}
          startIcon={<i class="las la-file-export la-lg"></i>}
          closeIcon
          color="grey"
          // component={RefundCollection}
          setValue={setValue}
          value={value}
          show={exportShowModal}
          setShow={setExportModal}
          resetModalFields={resetModalFields}
        >
          <ExportTableForm
            fields={fields}
            setFields={setFields}
            show={exportShowModal}
            setShow={setExportModal}
            route="/donors?"
            setCheckedFields={setCheckedFields}
            checkAllFields={checkAllFields}
            setExcelFileName="Donors Export"
          />
        </HeaderModal>
      </Box>
      <Grid container>
        <Grid item xs={12} md={12} lg={12}></Grid>
        {user?.role?.id < 3
          ? cards.map(({ header, body, currency }, index) => (
            <Grid item xs={12} md={3} lg={3}>
              <Card
                Header={header}
                body={body}
                currency={currency}
                loading={summaryLoading}
              />
            </Grid>
          ))
          : supportCards.map(({ header, body, currency }, index) => (
            <Grid item xs={12} md={6} lg={6}>
              <Card
                Header={header}
                body={body}
                currency={currency}
                loading={summaryLoading}
              />
            </Grid>
          ))}

        <Grid item xs={12} lg={11} mt="2.5em">
          <Box display={"flex"} alignItems="flex-start">
            {/* <span style={{border:'1px solid grey'}}></span> */}
            <TableFilter
              value={localFilters}
              setValue={setLocalFilters}
              filters={filters}
              withDonor
              setFilters={setFilters}
              defaultState={defaultState}
              defaultLocalState={defaultLocalState}
              noAnonymous={true}
              donorsPage
            />
          </Box>
        </Grid>

        <Grid item xs={12} lg={11} mt="2.5em">
          {/* <Typography variant="small" component={"p"} my="0.3em">
            Select the donor you want to export, then click the Export Button.
          </Typography> */}
          <ProductPerfomance
            columns={columns}
            data={rows}
            setShowSideNav={setShowSideNav}
            setClickedRow={setClickedRow}
            header={TableFilter}
            globalComponent={null}
            setSelectedRows={setSelectedRows}
            isLoading={isLoading}
            paginated
            changePage={handleChangePage}
            lastPage={lastPage}
          />
        </Grid>
      </Grid>
      <SideNav open={showSideNav} setOpen={setShowSideNav}>
        <DonorSideInfo clickedRow={clickedRow} />
      </SideNav>
    </>
  );
}

Donors.getLayout = function getLayout(page) {
  return (
    <PrivateRoute>
      {" "}
      <FullLayout>{page}</FullLayout>{" "}
    </PrivateRoute>
  );
};
